import { html, LitElement } from 'lit-element';
import { latexToHTML } from '../headerBlocks/utils.js';
import { defineElement } from '../classifier/utils.js';
import { Markup } from '../common/MarkupWrapper.js';
import { SlotsWrapper } from '../common/SlotsWrapper.js';
/**
 * @element response-modal-multi-item
 * @prop {Object} response - Response
 * @prop {Object} values - Values
 */
export class ResponseModalMultiItem extends LitElement {
  static get properties() {
    return {
      response: {
        type: Object,
        attribute: false,
      },
      value: {
        type: Object,
        attribute: false,
      },
    };
  }

  constructor() {
    super();

    defineElement('markup-wrapper', Markup);
    defineElement('slots-wrapper', SlotsWrapper);
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const { item } = this.response || {};
    const { markup, models } = item || {};

    if (!markup) return '';

    const markupSlots = models.map(model => {
      const current = (this.values || []).filter(
        value => value.id === model.id
      )[0];

      return html`
        <span
          class="markup-response-value ${(current && current.correctness) ||
          ''}"
          slot="${model.element.toLowerCase()}-${model.id}"
        >
          <math-rendering-element
            .label=${(current &&
              current.answer &&
              latexToHTML(current.answer)) ||
            'Not answered'}
          >
          </math-rendering-element>
        </span>
      `;
    });

    return html` <div class="modal-response-content">
      <markup-wrapper .markup=${markup} .markupSlots="${markupSlots}">
      </markup-wrapper>
    </div>`;
  }
}

export default ResponseModalMultiItem;
